import * as React from "react";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
    Card,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import MDButton from "components/MDButton";
import dayjs from "dayjs";
import Paper from "@mui/material/Paper";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { GET } from "APIclient";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import { Snackbar, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ReportingEmployees() {
    const empId = window.sessionStorage.getItem("empId");
    const theme = useTheme();
      const [optionValue, setOptionValue] = React.useState(false);
    const [statusFilter, setStatusFilter] = useState("");
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 10 });

    const [openModal, setOpenModal] = useState(false);
    const [data, setData] = useState(null);

    const [snackOpen, setSnackOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackColor, setSnackColor] = useState("success");
    const navigate = useNavigate();
    const handleClose = () => {
        setSnackOpen(false);
    };

    useEffect(() => {
        const fetchLeaveRequests = async () => {
            try {
                const url = `manager/reportingEmployee/${empId}`;
                // const response = await GET(url, {params: {page: 0, size: 20}});
                const response = await GET(url);

                if (response.status === 200) {
                    const data = response.data.data.paginatedData;
                    setData(data);
                }
            } catch (error) {
                console.error("Error fetching leave requests:", error);
                if (error.response) {
                    if (
                        error.response.status === 400 ||
                        error.response.status === 401 ||
                        error.response.status === 403
                    ) {
                        setSnackMessage(error.response.data.message);
                        setSnackColor("error");
                        setSnackOpen(true);
                    }
                } else {
                    setSnackMessage("Error fetching leave requests.");
                    setSnackColor("error");
                    setSnackOpen(true);
                }
            }
        };
        fetchLeaveRequests();
    }, []);

    // Handle the change in status filter
    const handleFilterChange = e => {
        setStatusFilter(e.target.value);
    };

      const handleView = (row, selectedOption) => {
        setOptionValue(selectedOption);    
        if (selectedOption === 'Assign Project') {
          navigate(`/assignProject`, { state: row.empId });
        }
      };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const options = [
        'Assign Project'
      ]
      const columns = [
        { field: "id", headerName: "#", width: 30, headerAlign: "center", align: "center" },
        {
            field: "empId",
            headerName: "Emp ID",
            width: 100,
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'employeeName',
            headerName: 'Employee Name',
            width: 150,
            align: 'left',
            headerAlign: 'left',
            valueGetter: (value, row) => {
                return `${row.firstName || ''} ${row.lastName || ''}`;
            },
        },
        { field: "starDate", headerName: "Reporting From", width: 110, headerAlign: "center", align: "center" },
        { field: "designation", headerName: "Designation", width: 110, headerAlign: "center", align: "center" },
        {
            field: "joinDate",
            headerName: "Joining Date",
            width: 100,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: "PL",
            headerName: "PL",
            type: "number",
            width: 50,
            headerAlign: "center",
            align: "center",
            renderCell: params => (
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    {params.value || "-"}
                </div>
            )
        },
        {
            field: "UPL",
            headerName: "UPL",
            type: "number",
            width: 50,
            headerAlign: "center",
            align: "center",
            renderCell: params => (
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    {params.value || "-"}
                </div>
            )
        },
        {
            field: "COFF",
            headerName: "COFF",
            type: "number",
            width: 60,
            headerAlign: "center",
            align: "center",
            renderCell: params => (
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    {params.value || "-"}
                </div>
            )
        },
        {
            field: "Action",
            headerName: "Action",
            type: "icon",
            width: 90,
            headerAlign: "center",
            align: "center",
            // renderCell: params => (
            //   <Tooltip title="View Details" arrow>
            //     <GridActionsCellItem
            //       key={`view-${params.id}`}
            //       icon={<VisibilityIcon />}
            //       label="View"
            //       color="primary"
            //       onClick={()=>handleViewDetails()}
            //     />
            //   </Tooltip>
            // )
            renderCell: params => {
                return (
                    <div>
                        <Select
                            variant="standard"
                            key={`menu-${params.row.empId}`}
                            value={optionValue}
                            onChange={(event) => handleView(params.row, event.target.value)} // Pass row and selected option
                            displayEmpty
                            defaultValue=""
                            style={{ width: '1px' }}
                            renderValue={(selected) => {
                                // If no option is selected, render the icon and text
                                if (!selected) {
                                    return (
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                            <MoreVertIcon style={{ marginRight: '8px', width: '' }} /> {/* Icon before the text */}
                                        </span>
                                    );
                                }
                                return selected; // Render selected option when it's chosen
                            }}
                        >
                            <MenuItem value="">
                                <em>Select</em>
                            </MenuItem>
                            {options?.map((option, index) => (
                                <MenuItem key={index} value={option}>
                                    {option ? option : <MoreVertIcon />}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                );
            },
        }
    ];
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox>
                <AppBar position="static">
                    <MDBox pt={1} pb={3} px={0}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={12} justifyContent="end">
                                <Card container>
                                    <MDBox p={2}>
                                        <MDTypography variant="h6">Reporting Employee</MDTypography>
                                        {/* <Divider /> */}
                                    </MDBox>
                                    <MDBox pb={2} px={3}>
                                        <Paper sx={{ width: "100%" }}>
                                            <DataGrid
                                                rows={data}
                                                columns={columns}
                                                getRowId={(row) => row.empId}
                                                paginationModel={paginationModel}
                                                pageSizeOptions={[10]}
                                                size="small"
                                                sx={{ border: 0, fontSize: "14px" }}
                                                aria-label="a dense table"
                                                onPaginationModelChange={setPaginationModel}
                                            />
                                        </Paper>
                                    </MDBox>
                                    <Divider />
                                </Card>
                            </Grid>
                        </Grid>
                    </MDBox>
                </AppBar>
            </MDBox>

            <Snackbar
                open={snackOpen}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                autoHideDuration={6000}
                onClose={handleClose}
            >
                <Alert
                    onClose={handleClose}
                    close={handleClose}
                    severity={snackColor == "success" ? "success" : "error"}
                    variant="filled"
                    sx={{ width: "100%", color: "#fff" }}
                >
                    {snackMessage}
                </Alert>
            </Snackbar>
        </DashboardLayout>
    );

    
}
